import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import {
  DashboardStatisticsItem,
  DashboardLicense,
  DashboardGraph,
  DashboardExamList,
  Loading
} from 'components';
import './Dashboard.css';

class Dashboard extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      periodList,
      timesList,
      statisticsData,
      monthlyTrainings,
      examListOrdering,
      examListByNo,
      selectedExamList,
      loading,
      maintainLicense
    } = this.props;

    const EmptyComponent = (
      <div className="empty-data">
        <div className="empty-text">
          {defineMessages(formatMessage({ id: 'ExamList_1', defaultMessage: '훈련이 없습니다' }))}
        </div>
        <div className="empty-sub-text">
          {defineMessages(formatMessage({ id: 'ExamList_2', defaultMessage: '훈련을 실행해 보세요!' }))}
        </div>
      </div>
    );

    const GraphList = [
      {
        whole: statisticsData.target,
        piece: statisticsData.send,
        type: "pie",
        graphColor: "#ffcf0e",
        message: defineMessages(formatMessage({ id: 'ExamListItem_4', defaultMessage: '발송' }))
          + defineMessages(formatMessage({ id: 'Dashboard_4', defaultMessage: '률' })),
        centerImage: "/img/exam/list_send.png"
      },
      {
        whole: statisticsData.target,
        piece: statisticsData.read,
        type: "pie",
        graphColor: "#f69c2e",
        message: defineMessages(formatMessage({ id: 'ExamListItem_5', defaultMessage: '열람' }))
          + defineMessages(formatMessage({ id: 'Dashboard_4', defaultMessage: '률' })),
        centerImage: "/img/exam/list_read.png"
      },
      {
        whole: statisticsData.target,
        piece: statisticsData.download,
        type: "pie",
        graphColor: "#711bd1",
        message: defineMessages(formatMessage({ id: 'CtExamChart_6', defaultMessage: '다운' }))
          + '/' + defineMessages(formatMessage({ id: 'TargetDetail_35', defaultMessage: '접속' }))
          + defineMessages(formatMessage({ id: 'Dashboard_4', defaultMessage: '률' })),
        centerImage: "/img/exam/list_down.png"
      },
      {
        whole: statisticsData.target,
        piece: statisticsData.infection,
        type: "pie",
        graphColor: "#db2828",
        message: defineMessages(formatMessage({ id: 'CtExamChart_4', defaultMessage: '감염' }))
          + '/' + defineMessages(formatMessage({ id: 'TargetDetail_36', defaultMessage: '유출' }))
          + defineMessages(formatMessage({ id: 'Dashboard_4', defaultMessage: '률' })),
        centerImage: "/img/exam/list_infection.png"
      }
    ];

    return (
      <div className="dashboard-component">
        <Loading active={loading} content={'Loading...'} />
        <div className="dashboard-contents">
          <div className="dashboard left">
            <div className="dashboard-summary">
              <DashboardStatisticsItem
                title={defineMessages(formatMessage({ id: 'ExamSummary_6', defaultMessage: '전체 훈련' }))}
                value={statisticsData.examCount}
                unitType={1}
              />
              <DashboardStatisticsItem
                title={defineMessages(formatMessage({ id: 'ExamSummary_10', defaultMessage: '예약 훈련' }))}
                value={statisticsData.reserveExamCount}
                unitType={1}
              />
              <DashboardStatisticsItem
                title={defineMessages(formatMessage({ id: 'ExamSummary_9', defaultMessage: '진행 중인 훈련' }))}
                value={statisticsData.progressExamCount}
                unitType={1}
              />
              <DashboardStatisticsItem
                title={defineMessages(formatMessage({ id: 'Dashboard_1', defaultMessage: '종료된 훈련' }))}
                value={statisticsData.endExamCount}
                unitType={1}
              />
            </div>
            <div className="dashboard-graph-contents">
              <div className="common-title">
                {defineMessages(formatMessage({ id: 'Dashboard_2', defaultMessage: '월별 실시한 훈련 수' }))}
              </div>
              <div className="dashboard-graph bar">
                <DashboardGraph
                  monthData={monthlyTrainings}
                  type="bar"
                  graphColor="#1ba8d1"
                  emptyComponent={EmptyComponent}
                />
              </div>
            </div>

          </div>
          <div className="dashboard center">
            <div className="dashboard-summary">
              <DashboardStatisticsItem
                title={defineMessages(formatMessage({ id: 'ExamChart_33', defaultMessage: '누적 훈련 대상' }))}
                value={statisticsData.target}
                unitType={2}
              />
              <DashboardStatisticsItem
                title={defineMessages(formatMessage({ id: 'ExamListItem_4', defaultMessage: '발송' }))}
                value={statisticsData.send}
                unitType={2}
              />
              <DashboardStatisticsItem
                title={defineMessages(formatMessage({ id: 'ExamListItem_5', defaultMessage: '열람' }))}
                value={statisticsData.read}
                unitType={2}
              />
              <DashboardStatisticsItem
                title={defineMessages(formatMessage({ id: 'CtExamChart_6', defaultMessage: '다운' }))
                  + '/' + defineMessages(formatMessage({ id: 'TargetDetail_35', defaultMessage: '접속' }))}
                value={statisticsData.download}
                unitType={2}
              />
              <DashboardStatisticsItem
                title={defineMessages(formatMessage({ id: 'CtExamChart_4', defaultMessage: '감염' }))
                  + '/' + defineMessages(formatMessage({ id: 'TargetDetail_36', defaultMessage: '유출' }))}
                value={statisticsData.infection}
                unitType={2}
              />
            </div>
            <div className="dashboard-graph-contents">
              <div className="common-title">
                {defineMessages(formatMessage({ id: 'ExamChart_1', defaultMessage: '훈련 결과 차트' }))}
              </div>
              <div className="dashboard-graph pie">
                {GraphList.map((item, index) => {
                  return (
                    <DashboardGraph
                      key={index}
                      whole={item.whole}
                      piece={item.piece}
                      type={item.type}
                      graphColor={item.graphColor}
                      message={item.message}
                      centerImage={item.centerImage}
                    />)
                })}
              </div>
            </div>
          </div>
          <div className="dashboard right">
            <DashboardLicense
              periodList={periodList}
              timesList={timesList}
              maintainLicense={maintainLicense}
            />
          </div>
        </div>
        <div className="dashboard-list">
          <div className="common-title">
            {defineMessages(formatMessage({ id: 'ExamSummary_9', defaultMessage: '진행중인 훈련' }))}
          </div>
          <DashboardExamList
            examListOrdering={examListOrdering}
            examListByNo={examListByNo}
            emptyComponent={EmptyComponent}
            selectedExamList={selectedExamList}
          />
        </div>
      </div >
    )
  }
}

export default injectIntl(Dashboard);


// WEBPACK FOOTER //
// ./src/script/components/dashboard/Dashboard.js